<template>

  <div class="big">
    <div class="page_title">剂型上限设置</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container"
           style="padding: 20px;">
        <div class="recipe-order big">
          <el-table v-loading="tableLoading"
                    :data="recipeData"
                    :span-method="objectSpanMethod"
                    border
                    style="width: 100%; margin-top: 20px"
                    :cell-style="cellStyle">
            <el-table-column v-for="item in tableHeader"
                             :key="item.prop"
                             :prop="item.prop"
                             :label="item.label"
                             :width="item.width"
                             :align="item.align">
            </el-table-column>

            <el-table-column label="默认医生诊后管理费上限">
              <template slot-scope="scope">
                <el-link type="primary"
                         :disabled=" module_id_array[0] ? !module_id_array.includes('760') : false"
                         @click="editorBtn(scope.row,1)">{{ scope.row.default_proportion }}</el-link>
              </template>
            </el-table-column>

            <el-table-column label="默认药品成本价比例">
              <template slot-scope="scope">

                <el-link type="primary"
                         :disabled=" module_id_array[0] ? !module_id_array.includes('760') : false"
                         @click="editorBtn(scope.row,2)">{{ scope.row.cost_price_proportion }}</el-link>

              </template>
            </el-table-column>

          </el-table>
          <!-- 比例 -->
          <el-dialog :title="dialogTitle"
                     :visible.sync="drugDialog"
                     width="600px"
                     style="text-align:left;"
                     :close-on-click-modal="true"
                     append-to-body
                     class="big">
            <div>
              <el-form :model="drugForm"
                       :rules="rules"
                       ref="drugFormRef"
                       label-width="180px"
                       class="demo-drugForm">

                <el-form-item v-show="ratioType==1"
                              label="默认医生诊后管理费上限"
                              prop="default_proportion"
                              style=" margin-top:20px">
                  <el-input-number v-model="drugForm.default_proportion"
                                   :controls="false"
                                   :precision="4"
                                   :min="0.0000"></el-input-number>
                </el-form-item>

                <el-form-item v-show="ratioType==2"
                              label="默认药品成本比例"
                              prop="cost_price_proportion"
                              style=" margin-top:20px">
                  <el-input-number v-model="drugForm.cost_price_proportion"
                                   :controls="false"
                                   :precision="2"
                                   :min="0.00"></el-input-number>
                </el-form-item>
              </el-form>
            </div>
            <span slot="footer"
                  class="dialog-footer">
              <el-button @click="save('drugFormRef')"
                         size="small"
                         type="primary"
                         plain>保 存</el-button>
              <el-button @click="close"
                         size="small"
                         plain>关 闭</el-button>
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import system from '../../../api/system';
export default {
  data() {
    return {
      drugDialog: false,
      dialogTitle: '',
      ratioType: '',
      drugForm: {
        default_proportion: '',
        cost_price_proportion: ''
      },
      rules: {
        cost_price_proportion: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        default_proportion: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      tableHeader: [
        {
          label: '药房名称',
          prop: 'hospital_name',
          width: 'auto',
          algin: 'center'
        },
        {
          label: '剂型名称',
          prop: 'drug_type_name',
          width: 'auto',
          algin: 'center'
        }
      ],
      recipeData: [],
      spanArr: [],
      position: 0
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if (this.module_id_array[0] && !this.module_id_array.includes('759')) {
        return;
      }
      this.spanArr = [];
      this.position = 0;
      this.tableLoading = true;
      system.getHospitalDrugTypeProportion().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.recipeData = data.list;
          this.rowspan();
          this.tableLoading = false;
        }
      });
    },
    rowspan() {
      for (let i = 0; i < this.recipeData.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.recipeData[i].hospital_name ===
            this.recipeData[i - 1].hospital_name
          ) {
            this.spanArr[this.position] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.position = i;
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    cellStyle(row, column) {
      if (row.columnIndex === 0) {
        return 'background-color: transparent';
      }
    },
    editorBtn(row, type) {
      this.ratioType = type;
      for (let key in row) {
        if (!row[key] && row[key] !== 0) {
          row[key] = '';
        }
      }
      this.dialogTitle = `${row.hospital_name}-${row.drug_type_name}`;
      this.drugDialog = true;
      this.$nextTick(() => {
        this.$refs['drugFormRef'].resetFields();
        this.drugForm = Object.assign(this.drugForm, row);
      });
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          system.setHospitalDrugTypeProportion(this.drugForm).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success('保存成功');
              this.drugDialog = false;
              this.getList();
            }
          });
        } else {
          return false;
        }
      });
    },
    close() {
      this.drugDialog = false;
    }
  }
};
</script>

<style lang="scss" scoped >
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
</style>